export default __webpack_public_path__ + "static/media/chairs.90d38472.png";